import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { useLanguage } from '../context/LanguageContext';
const MOCKUP_IMAGE = 'https://uploadthingy.s3.us-west-1.amazonaws.com/f9dftiuyCXSegMt95tQFws/Mockup_%28ROMPE_LA_MATRIX%29.png';
const BONUS_IMAGE = 'https://uploadthingy.s3.us-west-1.amazonaws.com/meNJZFMCTns5UvRVtwRyMW/Muckup_BONO1.png';
const BONUS2_IMAGE = 'https://uploadthingy.s3.us-west-1.amazonaws.com/hvKZSjThBjaanqccgt6axJ/Muckup_BONO2.png';
const BONUS3_IMAGE = 'https://uploadthingy.s3.us-west-1.amazonaws.com/2vNwJWKd8tpJZWGxBMBFMP/Muckup_BONO3.png';
export function PricingSection() {
  const {
    t
  } = useLanguage();
  const pricing = t.pricing;
  return <div className="container mx-auto px-4 max-w-5xl" data-id="element-124">
      <div className="relative" data-id="element-125">
        {/* Pricing card */}
        <div className="matrix-card p-8 md:p-10 rounded-2xl relative overflow-hidden" data-id="element-126">
          {/* Animated gradient background */}
          <motion.div className="absolute inset-0 opacity-10" style={{
          background: 'linear-gradient(135deg, #00d9ff 0%, #00ffcc 100%)'
        }} animate={{
          scale: [1, 1.1, 1],
          opacity: [0.1, 0.2, 0.1]
        }} transition={{
          duration: 4,
          repeat: Infinity
        }} data-id="element-127" />

          {/* Content */}
          <div className="relative z-10" data-id="element-128">
            <div className="max-w-3xl mx-auto" data-id="element-129">
              {/* Pricing info */}
              <div data-id="element-130">
                {/* Discount badge */}
                <motion.div className="inline-block mb-4" initial={{
                scale: 0
              }} whileInView={{
                scale: 1
              }} transition={{
                type: 'spring',
                delay: 0.2
              }} viewport={{
                once: true
              }} data-id="element-131">
                  <div className="bg-gradient-to-r from-matrix-accent to-matrix-accent-secondary text-black px-4 py-2 rounded-full font-bold text-sm uppercase tracking-wide" data-id="element-132">
                    {pricing.discount}
                  </div>
                </motion.div>

                {/* Title */}
                <h3 className="text-2xl md:text-3xl font-black text-white mb-2 uppercase" data-id="element-133">
                  {pricing.title}
                </h3>
                <p className="text-white/80 mb-8" data-id="element-134">{pricing.subtitle}</p>

                {/* Image moved here */}
                <motion.div initial={{
                opacity: 0,
                scale: 0.9
              }} whileInView={{
                opacity: 1,
                scale: 1
              }} transition={{
                duration: 0.8
              }} viewport={{
                once: true
              }} className="relative mb-8 max-w-md" data-id="element-135">
                  {/* Glow effect behind image */}
                  <div className="absolute inset-0 bg-matrix-accent/20 blur-3xl rounded-full" data-id="element-136" />

                  <motion.img src={MOCKUP_IMAGE} alt="ROMPE LA MATRIX 3-6-9 Mockup" className="relative z-10 w-full rounded-xl shadow-2xl shadow-matrix-accent/20" animate={{
                  y: [0, -10, 0]
                }} transition={{
                  duration: 6,
                  repeat: Infinity,
                  ease: 'easeInOut'
                }} data-id="element-137" />

                  {/* Floating particles around image */}
                  <motion.div className="absolute top-10 right-10 w-3 h-3 bg-matrix-accent rounded-full" animate={{
                  y: [0, -15, 0],
                  opacity: [0.3, 0.8, 0.3]
                }} transition={{
                  duration: 3,
                  repeat: Infinity
                }} data-id="element-138" />
                  <motion.div className="absolute bottom-20 left-10 w-2 h-2 bg-matrix-accent-secondary rounded-full" animate={{
                  y: [0, -10, 0],
                  opacity: [0.3, 0.8, 0.3]
                }} transition={{
                  duration: 4,
                  repeat: Infinity,
                  delay: 1
                }} data-id="element-139" />
                </motion.div>

                {/* Price */}
                <div className="mb-6" data-id="element-140">
                  <div className="flex items-baseline gap-3 mb-2" data-id="element-141">
                    <motion.span className="text-5xl md:text-6xl font-black gradient-text" initial={{
                    scale: 0.5,
                    opacity: 0
                  }} whileInView={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    type: 'spring',
                    delay: 0.3
                  }} viewport={{
                    once: true
                  }} data-id="element-142">
                      {pricing.price}
                    </motion.span>
                    <span className="text-2xl text-white/40 line-through" data-id="element-143">
                      {pricing.originalPrice}
                    </span>
                  </div>
                  <p className="text-matrix-accent text-sm font-semibold" data-id="element-144">
                    {pricing.guarantee}
                  </p>
                </div>

                {/* Features */}
                <div className="mb-8" data-id="element-145">
                  <p className="text-white font-bold mb-4 uppercase tracking-wide text-sm" data-id="element-146">
                    {pricing.includes}
                  </p>
                  <ul className="space-y-3" data-id="element-147">
                    {pricing.features.map((feature, index) => <motion.li key={index} className="flex items-start gap-3 text-white" initial={{
                    opacity: 0,
                    x: -20
                  }} whileInView={{
                    opacity: 1,
                    x: 0
                  }} transition={{
                    delay: 0.4 + index * 0.1
                  }} viewport={{
                    once: true
                  }} data-id="element-148">
                        <span className="text-matrix-accent text-xl flex-shrink-0 mt-1" data-id="element-149">
                          ✓
                        </span>
                        <span className="leading-relaxed" data-id="element-150">{feature}</span>
                      </motion.li>)}
                  </ul>
                </div>

                {/* FREE BONUS Section */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.3
              }} viewport={{
                once: true
              }} className="mb-8 relative" data-id="element-151">
                  {/* Bonus Card */}
                  <div className="bg-gradient-to-br from-yellow-500/10 to-orange-500/10 border-2 border-yellow-500/30 rounded-xl overflow-hidden" data-id="element-152">
                    {/* Bonus Header with Badge */}
                    <motion.div className="bg-gradient-to-r from-yellow-400 to-orange-500 px-6 py-4 flex items-center justify-center gap-3" animate={{
                    boxShadow: ['0 0 20px rgba(251, 191, 36, 0.5)', '0 0 30px rgba(251, 191, 36, 0.8)', '0 0 20px rgba(251, 191, 36, 0.5)']
                  }} transition={{
                    duration: 2,
                    repeat: Infinity
                  }} data-id="element-153">
                      <span className="text-2xl" data-id="element-154">🎁</span>
                      <span className="text-black font-black text-lg md:text-xl uppercase tracking-wide" data-id="element-155">
                        {pricing.bonus.badge}
                      </span>
                    </motion.div>

                    {/* Animated glow */}
                    <motion.div className="absolute inset-0 bg-gradient-to-r from-yellow-500/5 to-orange-500/5 pointer-events-none" animate={{
                    opacity: [0.3, 0.6, 0.3]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} data-id="element-156" />

                    <div className="relative z-10 p-6" data-id="element-157">
                      {/* Bonus Title */}
                      <h4 className="text-xl md:text-2xl font-black text-yellow-400 mb-4 leading-tight" data-id="element-158">
                        {pricing.bonus.title}
                      </h4>

                      {/* Bonus Image */}
                      <motion.div className="relative mb-6 max-w-sm" initial={{
                      opacity: 0,
                      scale: 0.95
                    }} whileInView={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.6,
                      delay: 0.4
                    }} viewport={{
                      once: true
                    }} data-id="element-159">
                        <div className="absolute inset-0 bg-yellow-500/20 blur-2xl rounded-full" data-id="element-160" />
                        <img src={BONUS_IMAGE} alt="Despertar BMT Bonus" className="relative z-10 w-full rounded-lg" data-id="element-161" />
                      </motion.div>

                      {/* Bonus Features */}
                      <p className="text-yellow-400 font-bold mb-3 uppercase tracking-wide text-sm" data-id="element-162">
                        {pricing.bonus.includes}
                      </p>
                      <ul className="space-y-2" data-id="element-163">
                        {pricing.bonus.features.map((feature, index) => <motion.li key={index} className="flex items-start gap-2 text-white/90 text-sm" initial={{
                        opacity: 0,
                        x: -20
                      }} whileInView={{
                        opacity: 1,
                        x: 0
                      }} transition={{
                        delay: 0.5 + index * 0.08
                      }} viewport={{
                        once: true
                      }} data-id="element-164">
                            <span className="text-yellow-400 text-lg flex-shrink-0" data-id="element-165">
                              ✓
                            </span>
                            <span className="leading-relaxed" data-id="element-166">{feature}</span>
                          </motion.li>)}
                      </ul>
                    </div>
                  </div>
                </motion.div>

                {/* BONUS 2 Section */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.3
              }} viewport={{
                once: true
              }} className="mb-8 relative" data-id="element-167">
                  {/* Bonus 2 Card */}
                  <div className="bg-gradient-to-br from-cyan-500/10 to-blue-500/10 border-2 border-cyan-500/30 rounded-xl overflow-hidden" data-id="element-168">
                    {/* Bonus 2 Header with Badge */}
                    <motion.div className="bg-gradient-to-r from-cyan-400 to-blue-500 px-6 py-4 flex items-center justify-center gap-3" animate={{
                    boxShadow: ['0 0 20px rgba(0, 217, 255, 0.5)', '0 0 30px rgba(0, 217, 255, 0.8)', '0 0 20px rgba(0, 217, 255, 0.5)']
                  }} transition={{
                    duration: 2,
                    repeat: Infinity
                  }} data-id="element-169">
                      <span className="text-2xl" data-id="element-170">🎁</span>
                      <span className="text-black font-black text-lg md:text-xl uppercase tracking-wide" data-id="element-171">
                        {pricing.bonus2.badge}
                      </span>
                    </motion.div>

                    {/* Animated glow */}
                    <motion.div className="absolute inset-0 bg-gradient-to-r from-cyan-500/5 to-blue-500/5 pointer-events-none" animate={{
                    opacity: [0.3, 0.6, 0.3]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} data-id="element-172" />

                    <div className="relative z-10 p-6" data-id="element-173">
                      {/* Bonus 2 Title */}
                      <h4 className="text-xl md:text-2xl font-black text-cyan-400 mb-4 leading-tight" data-id="element-174">
                        {pricing.bonus2.title}
                      </h4>
                      <p className="text-white/90 text-sm mb-4" data-id="element-175">
                        {pricing.bonus2.subtitle}
                      </p>

                      {/* Bonus 2 Image */}
                      <motion.div className="relative mb-6 max-w-sm" initial={{
                      opacity: 0,
                      scale: 0.95
                    }} whileInView={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.6,
                      delay: 0.4
                    }} viewport={{
                      once: true
                    }} data-id="element-176">
                        <div className="absolute inset-0 bg-cyan-500/20 blur-2xl rounded-full" data-id="element-177" />
                        <img src={BONUS2_IMAGE} alt="Protocolo SAL DE LA MATRIX Bonus" className="relative z-10 w-full rounded-lg" data-id="element-178" />
                      </motion.div>

                      {/* Bonus 2 Features */}
                      <p className="text-cyan-400 font-bold mb-3 uppercase tracking-wide text-sm" data-id="element-179">
                        {pricing.bonus2.includes}
                      </p>
                      <ul className="space-y-2 mb-4" data-id="element-180">
                        {pricing.bonus2.features.map((feature, index) => <motion.li key={index} className="flex items-start gap-2 text-white/90 text-sm" initial={{
                        opacity: 0,
                        x: -20
                      }} whileInView={{
                        opacity: 1,
                        x: 0
                      }} transition={{
                        delay: 0.5 + index * 0.08
                      }} viewport={{
                        once: true
                      }} data-id="element-181">
                            <span className="text-cyan-400 text-lg flex-shrink-0" data-id="element-182">
                              ✓
                            </span>
                            <span className="leading-relaxed" data-id="element-183">{feature}</span>
                          </motion.li>)}
                      </ul>

                      {/* Bonus 2 Benefit */}
                      <div className="bg-cyan-500/10 border border-cyan-500/30 rounded-lg p-4 mt-4" data-id="element-184">
                        <p className="text-cyan-300 font-semibold text-sm mb-2" data-id="element-185">
                          {pricing.bonus2.benefitLabel}
                        </p>
                        <p className="text-white/90 text-sm italic" data-id="element-186">
                          {pricing.bonus2.benefit}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>

                {/* BONUS 3 Section */}
                <motion.div initial={{
                opacity: 0,
                y: 20
              }} whileInView={{
                opacity: 1,
                y: 0
              }} transition={{
                duration: 0.6,
                delay: 0.3
              }} viewport={{
                once: true
              }} className="mb-8 relative" data-id="element-187">
                  {/* Bonus 3 Card */}
                  <div className="bg-gradient-to-br from-purple-500/10 to-pink-500/10 border-2 border-purple-500/30 rounded-xl overflow-hidden" data-id="element-188">
                    {/* Bonus 3 Header with Badge */}
                    <motion.div className="bg-gradient-to-r from-purple-400 to-pink-500 px-6 py-4 flex items-center justify-center gap-3" animate={{
                    boxShadow: ['0 0 20px rgba(168, 85, 247, 0.5)', '0 0 30px rgba(168, 85, 247, 0.8)', '0 0 20px rgba(168, 85, 247, 0.5)']
                  }} transition={{
                    duration: 2,
                    repeat: Infinity
                  }} data-id="element-189">
                      <span className="text-2xl" data-id="element-190">🎁</span>
                      <span className="text-black font-black text-lg md:text-xl uppercase tracking-wide" data-id="element-191">
                        {pricing.bonus3.badge}
                      </span>
                    </motion.div>

                    {/* Animated glow */}
                    <motion.div className="absolute inset-0 bg-gradient-to-r from-purple-500/5 to-pink-500/5 pointer-events-none" animate={{
                    opacity: [0.3, 0.6, 0.3]
                  }} transition={{
                    duration: 3,
                    repeat: Infinity
                  }} data-id="element-192" />

                    <div className="relative z-10 p-6" data-id="element-193">
                      {/* Bonus 3 Title */}
                      <h4 className="text-xl md:text-2xl font-black text-purple-400 mb-2 leading-tight" data-id="element-194">
                        {pricing.bonus3.title}
                      </h4>
                      <p className="text-white/90 text-sm mb-4" data-id="element-195">
                        {pricing.bonus3.subtitle}
                      </p>

                      {/* Bonus 3 Image */}
                      <motion.div className="relative mb-6 max-w-sm" initial={{
                      opacity: 0,
                      scale: 0.95
                    }} whileInView={{
                      opacity: 1,
                      scale: 1
                    }} transition={{
                      duration: 0.6,
                      delay: 0.4
                    }} viewport={{
                      once: true
                    }} data-id="element-196">
                        <div className="absolute inset-0 bg-purple-500/20 blur-2xl rounded-full" data-id="element-197" />
                        <img src={BONUS3_IMAGE} alt="Cómo Explicar tu Despertar Bonus" className="relative z-10 w-full rounded-lg" data-id="element-198" />
                      </motion.div>

                      {/* Bonus 3 Features */}
                      <p className="text-purple-400 font-bold mb-3 uppercase tracking-wide text-sm" data-id="element-199">
                        {pricing.bonus3.includes}
                      </p>
                      <ul className="space-y-2 mb-4" data-id="element-200">
                        {pricing.bonus3.features.map((feature, index) => <motion.li key={index} className="flex items-start gap-2 text-white/90 text-sm" initial={{
                        opacity: 0,
                        x: -20
                      }} whileInView={{
                        opacity: 1,
                        x: 0
                      }} transition={{
                        delay: 0.5 + index * 0.08
                      }} viewport={{
                        once: true
                      }} data-id="element-201">
                            <span className="text-purple-400 text-lg flex-shrink-0" data-id="element-202">
                              ✓
                            </span>
                            <span className="leading-relaxed" data-id="element-203">{feature}</span>
                          </motion.li>)}
                      </ul>

                      {/* Bonus 3 Benefit */}
                      <div className="bg-purple-500/10 border border-purple-500/30 rounded-lg p-4 mt-4" data-id="element-204">
                        <p className="text-purple-300 font-semibold text-sm mb-2" data-id="element-205">
                          {pricing.bonus3.benefitLabel}
                        </p>
                        <p className="text-white/90 text-sm italic" data-id="element-206">
                          {pricing.bonus3.benefit}
                        </p>
                      </div>
                    </div>
                  </div>
                </motion.div>

                {/* CTA Button */}
                <CTAButton size="large" className="w-full justify-center" href="" showPriceBadge={true} data-id="element-207">
                  {pricing.cta}
                </CTAButton>
              </div>
            </div>
          </div>
        </div>

        {/* Decorative corner accents */}
        <div className="absolute -top-4 -left-4 w-20 h-20 border-l-2 border-t-2 border-matrix-accent/50" data-id="element-208" />
        <div className="absolute -bottom-4 -right-4 w-20 h-20 border-r-2 border-b-2 border-matrix-accent/50" data-id="element-209" />
      </div>
    </div>;
}